/**
* 共通プロパティー 
*/

export const map = new Map([
/* System's Defaults */
['default.lang','ja'],
['default.country','JP'],
['timezone','JST'],

/* MIMEタイプ */
['mime.type.image.gif','image/gif'],
['mime.type.image.jpeg','image/jpeg'],
['mime.type.image.pjpeg','image/pjpeg'],
['mime.type.image.png','image/png'],
['mime.type.image.xpng','image/x-png'],
['mime.type.image.bmp','image/bmp'],
['mime.type.image.xbmp','image/x-bmp'],
['mime.type.image.xmsbmp',' "image/x-MS-bmp'],

/* base64ヘッダー */
['base64.header',';base64,'],
['base64.header.png','data:image/png;base64,'],
['base64.header.jpg','data:image/jpeg;base64,'],

/* アップロード画像の上限（約10MB） */
['upload.img.filesize.max','10000000'],

/* イメージ識別用ヘッダー */
['image.bytes.starts.jpg','FFD8'],
['image.bytes.starts.png','89504E47'],
['image.bytes.starts.gif','47494638'],

/* Directories */
['dir.kiroku','kiroku'],
['dir.kensaku','kensaku'],
['dir.done','done'],
['dir.err','err'],
['dir.stop','stop'],
['dir.tmp','tmp'],

/* Listener */
['listener.wait','10000'],

/* ページ描画の待ち時間 */
['pagedraw.wait','500'],

/* Email */
['email.id','auto@memotta.com'],
['email.pw','redondo90277'],
['email.from','auto@memotta.com'],
['email.bcc','memottabcc@memotta.com'],
['email.sprt','sprt@memotta.com'],
['email.domain','memotta.com'],
['smtp','mail.memotta.com'],
['smtp.port','587'],

/* 自動生成するパスワードの文字数 */
['password.gen.length','10'],

/*
 * Firebase Push通知
*/

/* メモった！ */
['firebase.projectid.01001','memotta-85193'],
['firebase.key.01001','/appl/memotta/firebase/keys/memotta-85193-firebase-adminsdk-wsjv8-1f191b53ea.json'],

/* 健康管理onメモった！ */
['firebase.projectid.04001','memottahealthproj'],
['firebase.key.04001','/appl/memotta/firebase/keys/memottahealthproj-firebase-adminsdk-3vmjw-24fb6d917d.json'],

/* キニッタ！ */
['firebase.projectid.05001','p05001'],
['firebase.key.05001','/appl/memotta/firebase/keys/p05001-firebase-adminsdk-57aef-ba5a506396.json'],

/* 共通' */
['firebase.push.notification.multi.max','500'],
['firebase.push.notification.imagUrl','https://www.memotta.com/image/MemottaPushIcon.png'],

/*
 * Dynamic Link
*/

/* メモった！ */
['dynamiclink.01001.01','https://p01001.page.link/XktS'],
['dynamiclink.01001.02.1','https://p01001.page.link/?link='],
['dynamiclink.01001.02.2','https://memotta.com/01/p/login.html?'],
['dynamiclink.01001.02.3','&apn=memotta.and&isi=1515051715&ibi=com.memotta'],

/* イベントNo. */
['dynamiclink.01001.02.param.en','en'],
/* メモNo. */
['dynamiclink.01001.02.param.mn','mn'],
/* 年月日 */
['dynamiclink.01001.02.param.ymd','ymd'],

/* 健康管理onメモった！ */
['dynamiclink.04001.01','https://p04001.page.link/nYJz'],

/* キニッタ！(p05001) */
['dynamiclink.05001.01','https://p05001.page.link/u9DC'],
['dynamiclink.05001.02.1','https://p05001.page.link/?link='],
// ['dynamiclink.05001.02.2','https://www.esplanadeone.com/p05001/05/p/index.html?'],
['dynamiclink.05001.02.2','https://www.esplanadeone.com/p05001/index.html?'],
['dynamiclink.05001.02.3','&apn=com.esplanadeone.p05001&isi=1583712947&ibi=com.esplanadeone.p05001'],
/* 店舗ID */
['dynamiclink.05001.02.param.shpid','si'],
/* お店ホームページ */
['dynamiclink.05001.02.homepage','https://www.esplanadeone.com/p05001/S05001003/'],
/* イベントNo. */
['dynamiclink.05001.02.param.en','en'],

/* MyNote, PubNote */
['mynote.title.length','30'],
['mynote.body.length','128'],
['mynote.remark.length','512'],
['mynote.email','kiroku'],
['mynote.email.free.maxday','50'],
['mynote.email.fere.max','1000'],
['mynote.email.premium.maxday','500'],
['mynote.email.premium.max','50000'],
['mynote.email.img.free.limit','30000000'],
['mynote.email.img.premium.limit','300000000'],
['mynote.email.premium.default.effectymd','19000101'],
['mysrch.email','kensaku'],
['mysrch.email.100','kensaku100'],
['mysrch.email.200','kensaku200'],
['mysrch.email.500','kensaku500'],
['mysrch.email.1000','kensaku1000'],
['mysrch.resultCount','50'],
['pubnote.email','pubnote'],
['pubnote.email.reply','pubnote_reply'],


/* Other email addresses */
['weight.kg.email','weight_kg'],
['weight.lb.email','weight_lb'],

/* Information */
['email.support','sprt@memotta.com'],

/* Site's logo */
['screen.common.site.logo','image/logosmall.jpg'],

/* Registration */
['PSNL_CMPNY_KBN.PSNL','1'],
['PSNL_CMPNY_KBN.CMPNY','2'],
['STATUS_MEMBER.MEMBER','00'],
['STATUS_MEMBER.REGISTRATION_IN_PROGRES','01'],
['STATUS_MEMBER.CANCELED','02'],
['STATUS_MEMBER.STATUS_SUSPENDED','03'],
['STATUS_MEMBER.STATUS_REGISTRATION_TIMEOUT','04'],
['STATUS_MEMBER.REGISTRATION_BY_SOMEBODY_IN_PROGRES','05'],
['USER_TYPE.MEMBER_00','00'],
['USER_TYPE.MEMBER_10','10'],
['CONNECT_METHOD.EMAIL','1'],
['CONNECT_METHOD.WEB','2'],
['CONNET_TERMINAL_TYPE_PC','P'],
['CONNET_TERMINAL_TYPE_IMODE','I'],
['CONNET_TERMINAL_TYPE_EZWEB','E'],
['CONNET_TERMINAL_TYPE_SOFTBANK','S'],
['CONNET_TERMINAL_TYPE_UNKNOWN','U'],
['CONNECT_STATUS.OK','000'],
['CONNECT_STATUS.LOGIN.DENIED','100'],
['CONNECT_STATUS.THEME.DENIED','101'],
['PASSWORD.GENERATION.LENGTH','10'],
['DOB.DEFAULT','19900101'],

/* Limitation */
['SYSTEM_STSRT.YYYY','2009'],
['SYSTEM_STSRT.YYYYMM','200901'],
['SYSTEM_STSRT.YYYYMMDD','20090101'],
['USER_TYPE.MEMBER_00.YEARS.PAST','1'],
['USER_TYPE.MEMBER_10.YEARS.PAST','5'],
['USER_TYPE.MEMBER_00.MONTHS.PAST','12'],
['USER_TYPE.MEMBER_10.MONTHS.PAST','120'],
['USER_TYPE.MEMBER_00.MONTHS.FUTURE','12'],
['USER_TYPE.MEMBER_10.MONTHS.FUTURE','60'],
['USER_TYPE.MEMBER_00.GROUPS','1'],
['USER_TYPE.MEMBER_10.GROUPS','5'],
['USER_TYPE.MEMBER_00.MEMBERS','50'],
['USER_TYPE.MEMBER_10.MEMBERS','200'],

/* Management */
['MINUTES_REGISTRATION_WAIT','15'],
['DAYS_BEFORE_PHYSICAL_DELETE','3'],

/* Achievement Status */
['ACHIEVEMENT_STATUS.NONE','0'],
['ACHIEVEMENT_STATUS.DONE','1'],

/* OperatorID */
['SYSTEM.ID','SYSTEM'],
['SYSTEM.ID.LONG','0'],

/* Option code */
['OPTION_CD.MYNOTE','001'],

/* MemoObject Type */
['MEMO_OBJECT_TYPE.GIF','01'],
['MEMO_OBJECT_TYPE.JPEG','02'],
['MEMO_OBJECT_TYPE.PNG','03'],
['MEMO_OBJECT_TYPE.BMP','04'],

/* Terminal */
['TERMINAL.OS.NAME.ANDROID','1'],
['TERMINAL.OS.NAME.IOS','2'],
['TERMINAL.OS.NAME.OTHERS','3'],

/* Display Mode */
['DISPLAY_MODE_YEARLY','Y'],
['DISPLAY_MODE_YEARLY_SUM','Z'],
['DISPLAY_MODE_MONTHLY','M'],
['DISPLAY_MODE_WEEKLY','W'],
['DISPLAY_MODE_DAYSPAST','P'],
['DISPLAY_MODE_YMD','D'],
['DISPLAY_MODE_OTHERS','O'],

/* マイページ */
['CALENDAR_TYPE_YEARLY','Y'],
['CALENDAR_TYPE_MONTHLY','M'],
['CALENDAR_TYPE_WEEKLY','W'],
['CALENDAR_PRELOAD_MONTHS','1'],

/* スワイプ
   スワイプと判断する移動量(横幅の何%かを指定） */
['SWIPE_MIN_MOVE_W_PERCENT','20'],

/* Memo Category */
['MEMO_CATEGORY.Memo','0001'],
['MEMO_CATEGORY.Meal','0201'],
['MEMO_CATEGORY.BodyWeight','0301'],
['MEMO_CATEGORY.BodyTemp','0302'],
['MEMO_CATEGORY.BloodPressure','0303'],
['MEMO_CATEGORY.MenstrualPeriod','0304'],
['MEMO_CATEGORY.Sex','0305'],

/* Unit */
['UNIT.CODE.mm','01'],
['UNIT.CODE.cm','02'],
['UNIT.CODE.m','03'],
['UNIT.CODE.km','04'],
['UNIT.CODE.inch','05'],
['UNIT.CODE.feet','06'],
['UNIT.CODE.yard','07'],
['UNIT.CODE.mi','08'],
['UNIT.CODE.g','11'],
['UNIT.CODE.kg','12'],
['UNIT.CODE.lb','13'],
['UNIT.CODE.ct','14'],
['UNIT.CODE.ft','15'],
['UNIT.CODE.lt','16'],
['UNIT.CODE.gal','17'],
['UNIT.CODE.mmhg','18'],
['UNIT.CODE.percent','19'],

['UNIT.SINGULAR.01','mm'],
['UNIT.SINGULAR.02','cm'],
['UNIT.SINGULAR.03','m'],
['UNIT.SINGULAR.04','km'],
['UNIT.SINGULAR.05','inch'],
['UNIT.SINGULAR.06','feet'],
['UNIT.SINGULAR.07','yard'],
['UNIT.SINGULAR.08','mile'],
['UNIT.SINGULAR.11','g'],
['UNIT.SINGULAR.12','kg'],
['UNIT.SINGULAR.13','lb'],
['UNIT.SINGULAR.14','C'],
['UNIT.SINGULAR.15','F'],
['UNIT.SINGULAR.16','l'],
['UNIT.SINGULAR.17','gal'],
['UNIT.SINGULAR.18','mmHg'],
['UNIT.SINGULAR.19','%'],

['UNIT.PLURAL.01','mm'],
['UNIT.PLURAL.02','cm'],
['UNIT.PLURAL.03','m'],
['UNIT.PLURAL.04','km'],
['UNIT.PLURAL.05','inches'],
['UNIT.PLURAL.06','foot'],
['UNIT.PLURAL.07','yards'],
['UNIT.PLURAL.08','miles'],
['UNIT.PLURAL.11','g'],
['UNIT.PLURAL.12','kg'],
['UNIT.PLURAL.13','lbs'],
['UNIT.PLURAL.14','C'],
['UNIT.PLURAL.15','F'],
['UNIT.PLURAL.16','l'],
['UNIT.PLURAL.17','gal'],
['UNIT.PLURAL.18','mmHg'],
['UNIT.PLURAL.19','%'],

['UNIT.SYMBOL.01','mm'],
['UNIT.SYMBOL.02','cm'],
['UNIT.SYMBOL.03','m'],
['UNIT.SYMBOL.04','km'],
['UNIT.SYMBOL.05','"'],
['UNIT.SYMBOL.06',"'"],
['UNIT.SYMBOL.07','yards'],
['UNIT.SYMBOL.08','miles'],
['UNIT.SYMBOL.11','g'],
['UNIT.SYMBOL.12','kg'],
['UNIT.SYMBOL.13','lbs'],
['UNIT.SYMBOL.14','C'],
['UNIT.SYMBOL.15','F'],
['UNIT.SYMBOL.16','litter'],
['UNIT.SYMBOL.17','galon'],
['UNIT.SYMBOL.18','mmHg'],
['UNIT.SYMBOL.19','%'],

/* Graph */
['graph.common.bg.R','255'],
['graph.common.bg.G','255'],
['graph.common.bg.B','223'],
['graph.common.ratio.max','2'],
['graph.common.ratio.step','0.2'],
['graph.common.margin.x','20'],
['graph.common.usage.font.size','16'],

/* バーコード/QRコード */
['barcode.format.qr','01'],
['barcode.qr.width','140'],
['barcode.qr.height','140'],
['barcode.format.ean13','02'],
['barcode.ean13.width','160'],
['barcode.ean.height','40'],
['barcode.format.nw7','03'],
['barcode.nw7.width','160'],
['barcode.nw7.height','40'],

/* 体重グラフ */
['A0002.line.stroke.bodyWeight','3'],
['A0002.line.stroke.targetBodyWeight','3'],
['A0002.line.stroke.recomendedBodyWeight','3'],
['A0002.line.color.R.bodyWeight','255'],
['A0002.line.color.G.bodyWeight','0'],
['A0002.line.color.B.bodyWeight','0'],
['A0002.line.color.R.targetBodyWeight','0'],
['A0002.line.color.G.targetBodyWeight','0'],
['A0002.line.color.B.targetBodyWeight','255'],
['A0002.line.color.R.recomendedBodyWeight','255'],
['A0002.line.color.G.recomendedBodyWeight','94'],
['A0002.line.color.B.recomendedBodyWeight','25'],
/* Graph(JFreeChart) */
['A0002.graph.default.width','440'],
['A0002.graph.default.height','600'],
['A0002.graph.scrollbar.height','20'],
['A0002.graph.col.width','30'],
/* 横軸（日付）の設定 */
['A0002.graph.x.tickunit.interval','2'],
['A0002.graph.x.tickunit.font.size','10'],
['A0002.graph.x.lable.font.size','14'],
['A0002.graph.x.tickunit.month.font.size','16'],
['A0002.graph.x.lable.month.font.size','14'],
/* 縦軸（体温）の設定 */
['A0002.graph.y.tickunit.font.size','10'],
['A0002.graph.y.lable.font.size','14'],

/* 基礎体温グラフ */
/* 過去日数 */
['B0003.DAYS.PAST','60'],
/* 基礎体温グラフ描画の最長地、最大値 */
['B0003.DRAW.MIN.14','35'],
['B0003.DRAW.MAX.14','38'],
['B0003.DRAW.GAP.14','0.1'],
['B0003.DRAW.MIN.15','95'],
['B0003.DRAW.MAX.15','100'],
['B0003.DRAW.GAP.15','1'],
['B0003.line.stroke','3'],
['B0003.line.color.R.BBT','229'],
['B0003.line.color.G.BBT','0'],
['B0003.line.color.B.BBT','134'],
['B0003.shape.color.R.PERIOD','65'],
['B0003.shape.color.G.PERIOD','105'],
['B0003.shape.color.B.PERIOD','225'],
/* Graph(JFreeChart) */
['B0003.graph.default.width','640'],
['B0003.graph.default.height','600'],
['B0003.graph.scrollbar.height','20'],
/* 横軸（日付）の設定 */
['B0003.graph.x.tickunit.interval','2'],
['B0003.graph.x.tickunit.font.size','10'],
['B0003.graph.x.lable.font.size','14'],
/* 縦軸（体温）の設定 */
['B0003.graph.y.tickunit.font.size','10'],
['B0003.graph.y.lable.font.size','14'],

/* 血圧グラフ */
['B040030.line.stroke.bp','3'],
['B040030.line.stroke.recomendedBodyWeight','3'],
['B040030.line.color.R.bpu1','0'],
['B040030.line.color.G.bpu1','0'],
['B040030.line.color.B.bpu1','255'],
['B040030.line.color.R.bpu2','0'],
['B040030.line.color.G.bpu2','255'],
['B040030.line.color.B.bpu2','255'],
['B040030.line.color.R.bpu3','50'],
['B040030.line.color.G.bpu3','205'],
['B040030.line.color.B.bpu3','50'],
['B040030.line.color.R.bpl1','255'],
['B040030.line.color.G.bpl1','0'],
['B040030.line.color.B.bpl1','0'],
['B040030.line.color.R.bpl2','255'],
['B040030.line.color.G.bpl2','153'],
['B040030.line.color.B.bpl2','0'],
['B040030.line.color.R.bpl3','238'],
['B040030.line.color.G.bpl3','130'],
['B040030.line.color.B.bpl3','238'],
['B040030.line.color.R.max','255'],
['B040030.line.color.G.max','105'],
['B040030.line.color.B.max','180'],
['B040030.line.color.R.min','192'],
['B040030.line.color.G.min','192'],
['B040030.line.color.B.min','192'],
/* Graph(JFreeChart) */
['B040030.graph.default.width','440'],
['B040030.graph.default.height','600'],
['B040030.graph.scrollbar.height','20'],
['B040030.graph.col.width','30'],
/* 横軸（日付）の設定 */
['B040030.graph.x.tickunit.days','10'],
['B040030.graph.x.tickunit.font.size','10'],
['B040030.graph.x.lable.font.size','14'],
['B040030.graph.x.tickunit.month.font.size','16'],
['B040030.graph.x.lable.month.font.size','14'],
/* 縦軸の設定 */
['B040030.graph.y.tickunit.font.size','10'],
['B040030.graph.y.lable.font.size','14'],
/* 時間帯 */
['B040030.graph.start.hh24.morning','04'],
['B040030.graph.end.hh24.morning','12'],
['B040030.graph.start.hh24.night','16'],
['B040030.graph.end.hh24.night','24'],
/* 閾値 */
['B040030.graph.limit.bpu','140'],
['B040030.graph.limit.bpl','90'],

/* Actionflag */
['P101002.Action.UploadImage','UI'],
['P101002.Action.RemoveImage','RI'],
['P101002.Action.SaveMemo','SM'],
['P101002.Action.NewMemo','NM'],
['P101002.Action.Return','RT'],

['P101003.Action.Save','SV'],
['P101003.Action.Top','TP'],
['P101003.Action.Prev','PV'],
['P101003.Action.Next','NX'],
['P101003.Action.Last','LT'],
['P101003.Action.Delete','DL'],
['P101003.Action.Edit','ED'],
['P101003.Action.MyPage','MP'],
['P101003.Image.Size.Small','100'],
['P101003.Image.Num_Row','2'],
['P101003.ReturnLines','10'],

['P101011.Action.Refresh','RF'],
['P101011.Action.Prev','PV'],
['P101011.Action.Next','NX'],
['P101011.Action.Curr','CR'],
['P101011.Action.Jump','JP'],
['P101011.Action.AddMemo','AM'],
['P101011.Action.SaveRemark','SR'],

['P101013.Action.Refresh','RF'],
['P101013.Action.Init','IT'],

['P103010.Action.Refresh','RF'],
['P103010.Action.Save','SV'],

['P103011.Action.Refresh','RF'],
['P103011.Action.Save','SV'],

['P103012.Action.Refresh','RF'],
['P103012.Action.Save','SV'],

['P109001.Action.Init','IT'],
['P109001.Action.Save','SV'],

['P109004.Action.Init','IT'],
['P109004.Action.Save','SV'],

['P109008.Action.Send','SD'],

['P109009.Action.Send','SD'],

/* Copyright */
['COPYRIGHT','(C)2014 Esplanade One Co., Ltd.'],

/* 体調確認 */
['screen.s04001012.sel.max','20'],

/* メンバー検索 */
['screen.s01001055.maxResults','50'],
['screen.s04001013.maxResults','50'],

/* 設定内容 */
['config.code.seach','0001'],
['config.code.seach.refuse','0'],
['config.code.seach.allow','1'],

/* Store code */
['store.apple','A'],
['store.google','G'],

/*Json status code */
['JSON.STATUS.OK','000'],
['JSON.STATUS.NoUpdatedNeeded','001'],
['JSON.STATUS.ERROR','101'],
['JSON.STATUS.IDNotFoundException','102'],
['JSON.STATUS.NotAuthorizedException','103'],
['JSON.STATUS.WrongPasswordException','104'],
['JSON.STATUS.DuplicateProjectTitle','105'],
['JSON.STATUS.WARN','106'],
['JSON.STATUS.INFO','107'],

/*Actionflag */
['M109004.Action.Read','RD'],
['M109004.Action.Save','SV'],
['M109005.Action.Save','SV'],
['M103010.Action.Read','RD'],
['M103010.Action.Save','SV'],
['M103011.Action.Read','RD'],
['M103011.Action.Save','SV'],
['M103020.Action.Read','RD'],
['M103020.Action.Save','SV'],
['M103040.Action.Read','RD'],
['M103040.Action.Save','SV'],
['M103060.Action.List','LS'],
['M103060.Action.Save','SV'],
['M103060.Action.Delete','DL'],

['M103060.Fever.ave.lo','35.0'],
['M103060.Fever.ave.hi','37.4'],
['M103060.Fever.days','4'],

/* メモ添付画像 */
['memo.img.width','640'],
['android.img.small.width','200'],
/* プロフィール画像 */
['prof.img.width','200'],
['prof.img.height','200'],

/* プロジェクト画像 */
['project.logo.width','128'],
['project.logo.height','128'],
['project.photo.width','400'],
['project.photo.height','400'],
['Logo1.height','69'],
['Logo2.height','70'],
['Logo2.margin.bottom','50'],

/*####################################*/
/* メモった2用 */
/*####################################*/

/* ログ用メッセージ */
['memotta.log.error','*****ERROR*****'],
['memotta.log.start','*START*'],
['memotta.log.end','*END*'],

/* localstorage */
['01001.ls.datatype.personal','10'],
['01001.ls.datatype.project','20'],
['01001.ls.datatype.public','30'],

/* アクションフラグ */
['B000010.actionFlag.R','R'],
['B040030.actionFlag.R','R'],
['C000010.actionFlag.D','D'],
['C000011.actionFlag.R','R'],
['C000012.actionFlag.C','C'],
['C000012.actionFlag.U','U'],
['C000020.actionFlag.R','R'],
['C000030.actionFlag.C','C'],
['C000040.actionFlag.A','A'],
['C000040.actionFlag.C','C'],
['C000040.actionFlag.R','R'],
['C000040.actionFlag.U','U'],
['C000040.actionFlag.D','D'],
['C000050.actionFlag.R','R'],
['C000060.actionFlag.C','C'],
['C000060.actionFlag.R','R'],
['C000060.actionFlag.U','U'],
['C000070.actionFlag.R','R'],
['C000071.actionFlag.U','U'],
['C000080.actionFlag.U','U'],
['C000090.actionFlag.C','C'],
['C000100.actionFlag.R','R'],
['C000120.actionFlag.R','R'],
['C000120.actionFlag.U','U'],
['C000130.actionFlag.C','C'],
['C000130.actionFlag.R','R'],
['C000130.actionFlag.D','D'],
['C000140.actionFlag.R','R'],
['C000140.actionFlag.U','U'],
['C000150.actionFlag.R','R'],
['C000160.actionFlag.R','R'],
['C000500.actionFlag.C','C'],
['C000500.actionFlag.R','R'],
['C000500.actionFlag.U','U'],
['C000500.actionFlag.D','D'],
['C010010.actionFlag.R','R'],
['C010011.actionFlag.R','R'],
['C010020.actionFlag.R','R'],
['C010030.actionFlag.R','R'],
['C010040.actionFlag.C','C'],
['C010040.actionFlag.U','U'],
['C010040.actionFlag.D','D'],
['C010050.actionFlag.C','C'],
['C010050.actionFlag.U','U'],
['C010050.actionFlag.D','D'],
['C010060.actionFlag.R','R'],
['C010070.actionFlag.R','R'],
['C010080.actionFlag.R','R'],
['C040011.actionFlag.R','R'],
['C040040.actionFlag.R','R'],
['C040040.actionFlag.U','U'],
['C040050.actionFlag.R','R'],
['C040050.actionFlag.U','U'],
['C040060.actionFlag.C','C'],
['C040060.actionFlag.R','R'],
['C040060.actionFlag.D','D'],

['C010080.ReturnLines','100'],

/* パラメーター用 */
['parm.boolean.true','1'],
['parm.boolean.false','0'],

/* 個人、法人区分 */
['contract.type.psnl','0'],
['contract.type.Cmpny','1'],

/* 役割コード */
['roll.owner','01'],
['roll.manager','02'],
['roll.user','03'],
['roll.staff','04'],
['roll.member','05'],

/* 招待ステータスコード */
['invitation.status.never','0'],
['invitation.status.sent','1'],
['invitation.status.approved','2'],
['invitation.status.refused','3'],

/* プロジェクト公開区分 */
['project.pub.close','0'],
['project.pub.open','1'],

/* イベント区分 */
['event.kbn.notifyonly','0'],
['event.kbn.attndnc.required','1'],

/* 出欠リスト公開 */
['event.attndnc.list.show.no','0'],
['event.attndnc.list.show.memonly','1'],

/*-------------------------------------*/
/* アクションレコードタイプ */
/*-------------------------------------*/

/* コメント */
['art.01001.mpt020.cmnt','1'],
/* 出席確率 */
['art.01001.mpt021.psblty','1'],
/* 出欠 */
['art.01001.mpt022.attndnc','1'],

/*------------------------------------- */
/* アクションレコードバリュー */
/*------------------------------------- */

/* 出欠コード（欠席） */
['art.01001.mpt022.attndnc.absence','0'],
/* 出欠コード（出席） */
['art.01001.mpt022.attndnc.attend','1'],
/* 出欠コード（保留） */
['art.01001.mpt022.attndnc.hold','2'],
/* 出欠コード（遅刻） */
['art.01001.mpt022.attndnc.late','3'],
/* 出欠コード（早退） */
['art.01001.mpt022.attndnc.early','4'],
/* 出欠コード（見学） */
['art.01001.mpt022.attndnc.watch','5'],
/* 出欠コード（未回答） */
['art.01001.mpt022.attndnc.none','X'],

/*------------------------------------- */
/* イベントレコードタイプ */
/*------------------------------------- */

/* 出欠回答期限 */
['ert.01001.mpt026.byDate','4'],
/* 集合時刻 */
['ert.01001.mpt026.mtHHmm','7'],
/* 開催場所 */
['ert.01001.mpt029.evntPlc','1'],
/* 集合場所 */
['ert.01001.mpt029.mtPlc','2'],
/* 参照URL */
['ert.01001.mpt029.url','3'],
/* 詳細 */
['ert.01001.mpt029.dtl','4'],
/* クーポンコード */
['ert.01001.mpt029.cCd','5'],
/* クーポン名称 */
['ert.01001.mpt029.cNm','6'],
/* クーポン説明 */
['ert.01001.mpt029.cDsc','7'],
/* 出欠一覧をメンバーに公開する */
['ert.01001.mpt031.attndnc_list_show','1'],

/*------------------------------------- */
/* 権限管理用パーミッション */
/*------------------------------------- */
/* 参照パーミッション */
['permission.r','R'],
/* 更新パーミッション */
['permission.w','W'],
/* 実行パーミッション */
['permission.x','X'],

/*------------------------------------- */
/* 体調コード */
/*------------------------------------- */
['physclCndCode.good','0'],
['physclCndCode.usual','1'],
['physclCndCode.nogood','2'],
['physclCndCode.bad','3'],

/*------------------------------------- */
/* ストア情報 */
/*------------------------------------- */
/*メモった！2用 */
['store.product.id.01.10','com.memotta.01.10'],
/* 健康管理用 */
['store.product.id.04.10','memotta_plan_10'],
/* 共通 */
['store.product.status.owned','owned'],
['store.product.status.expired','expired'],

/*------------------------------------- */
/* バッチ用(MemottaBatch2) */
/*------------------------------------- */
/* イベントリマインダー（何分前にリマインド通知をするかを設定） */
['reminder.01.001.notify.prior.mm','5'],
['reminder.templatefile.01','01001_007'],
['reminder.templatefile.05','05001_010']
]);